// extracted by mini-css-extract-plugin
export default {"root":"PreviewAvatarMedia_root__Z6eTH","layout-container":"PreviewAvatarMedia_layout-container__yufVX","spinnerWrapper":"PreviewAvatarMedia_spinnerWrapper__HrPjz","avatarVideoContainer":"PreviewAvatarMedia_avatarVideoContainer__KWBiZ","gradient":"PreviewAvatarMedia_gradient__s+m2J","previewUnavailable":"PreviewAvatarMedia_previewUnavailable__irzYL"};
    if(module.hot) {
      // 1763464084340
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  